import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from 'prosemirror-state';

export const DefaultHeading = Extension.create({
  name: 'defaultHeading',
  addProseMirrorPlugins() {
    let isUpdating = false;
    return [
      new Plugin({
        key: new PluginKey('defaultHeading'),
        appendTransaction: (transactions, oldState, newState) => {
          if (isUpdating) {
            return null;
          }
          if (!transactions.some((tr) => tr.docChanged)) {
            return null;
          }
          const { doc, schema, tr } = newState;
          let shouldUpdate = false;
          const firstNode = doc.firstChild;
          if (firstNode != null) {
            if (firstNode.type !== schema.nodes.heading && oldState.doc.children.length === 1) {
              tr.setNodeMarkup(0, schema.nodes.heading, { level: 1 });
              shouldUpdate = true;
            }
          } else {
            tr.insert(0, schema.nodes.heading.create({ level: 1 }));
            shouldUpdate = true;
          }
          if (shouldUpdate) {
            isUpdating = true;
            try {
              return tr;
            } finally {
              setTimeout(() => {
                isUpdating = false;
              }, 0);
            }
          }
          return null;
        },
        props: {
          handleKeyDown: (view, event) => {
            if (isUpdating) {
              return false;
            }
            if (event.key !== 'Enter' || event.shiftKey) {
              return false;
            }
            const { state } = view;
            const { selection, doc, schema } = state;
            const { $from } = selection;
            const node = doc.nodeAt($from.pos - $from.parentOffset);
            if (node?.type !== schema.nodes.heading || $from.pos !== $from.end()) {
              return false;
            }
            view.dispatch(
              state.tr.split($from.pos, 1, [
                {
                  type: schema.nodes.paragraph,
                },
              ])
            );
            return true;
          },
        },
      }),
    ];
  },
});
